// extracted by mini-css-extract-plugin
export default {"container":"checkbox_container__AHSZh","checkmark":"checkbox_checkmark__vXlIE","custom":"checkbox_custom__VNTV7"};